// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__pTClt","title":"Message_title__GO9WR","text-wrapper":"Message_text-wrapper__PTm0a","text":"Message_text__qdY88"};